import React from 'react'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import cx from 'classnames'

const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms))

class Progress extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    seconds: PropTypes.number.isRequired,
  }

  state = {
    value: 0,
  }

  ref = React.createRef()

  componentDidMount = async () => {
    const {seconds} = this.props
    const bar = this.ref.current.querySelector('div[data-bar]')
    const interval = seconds / 100

    for (let value = 0; value < 100; value++) {
      this.setState({value: value + 1})
      await sleep(interval * 1000)
      bar.style.width = value + '%'
    }
  }

  render = () => {
    const {classes, className} = this.props
    const {value} = this.state

    return (
      <div
        ref={this.ref}
        className={cx(classes.root, className)}
        value={value}
        max={100}
      >
        <div data-bar className={classes.bar} />
      </div>
    )
  }
}

export default injectSheet({
  root: {
    width: '100%',
    height: 0,
    appearance: 'none',
  },
  bar: {
    display: 'block',
    width: 0,
    height: 5,
    backgroundColor: '#0055b8',
    willChange: 'width',
    transition: 'width 0.25s ease-in',
  },
})(Progress)
